import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Footer.css";
import MenuFooter from "./MenuFooter";
import { menuItems } from "../helpers/menuItems";
import { Divider, Typography, Stack } from "@mui/material";
import { isMobile } from "react-device-detect";
import logo from "../assets/isotipo.png";
import cash from "../assets/cashblanco.png";
import transferencia from "../assets/transferenciablanco.png";
import mercadopago from "../assets/mercadopagoblanco.png";

function Footer() {
  const navigate = useNavigate();

  const currentYear = new Date().getFullYear();

  const handleLogoClick = () => {
    navigate("/");
    window.scrollTo(0, 0);
  };

  return (
    <div className="footer">
      <div
        style={{
          width: "80%",
          display: "flex",
          height: "100%",
          flexDirection: isMobile ? "column" : "row",
          margin: "0 auto",
          padding: isMobile ? "1rem 20px" : 0,
          justifyContent: isMobile ? "center" : "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ color: "#fafafa", width:'100%' }}>
            <Typography
              my="1.2rem"
              style={{ fontSize: !isMobile ? "1.6rem" : "1.2rem" }}
              textTransform="uppercase"
              variant="h6"
            >
              {" "}
              Formas de pago
            </Typography>

            <div style={{ display: "flex", alignItems: "flex-start", justifyContent:'space-between', width:'100%', }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center"
                }}
              >
                <img
                  src={cash}
                  style={{ maxWidth: !isMobile ? "40px" : "30px" }}
                  alt="icono-cash"
                />
                <Typography
                  my=".3rem"
                  style={{ fontSize: !isMobile ? "1rem" : ".8rem" }}
                  textTransform="uppercase"
                  variant="body-1"
                >
                  {" "}
                  Efectivo
                </Typography>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center"
                }}
              >
                <img
                  src={transferencia}
                  style={{ maxWidth: !isMobile ? "35px" : "25px" }}
                  alt="icono-banco"
                />
                <Typography

                  my=".3rem"
                  style={{
                    fontSize: !isMobile ? "1rem" : ".8rem",
                   maxWidth: isMobile ? '100px' :'200px', textAlign:'center'
                  }}
                  textTransform="uppercase"
                  variant="body-1"
                >
                  {" "}
                  Transferencia bancaria
                </Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center"
                }}
              >
                <img
                  src={mercadopago}
                  style={{ maxWidth: !isMobile ? "40px" : "35px" }}
                  alt="logo-mercado-pago"
                />
                <Typography
                  my=".3rem"
                  style={{ fontSize: !isMobile ? "1rem" : ".8rem" }}
                  textTransform="uppercase"
                  variant="body-1"
                >
                  {" "}
                 mercado pago
                </Typography>
              </div>
            </div>
          </div>

          <div
            style={{
              width: "auto",
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              alignItems: isMobile ? "center" : "flex-end",
            }}
            onClick={handleLogoClick}
          >
            <img
              src={logo}
              style={{ maxWidth: isMobile ? "200px" : "100px" }}
              alt="logo-conecta"
            />
          </div>
        </div>

        <div style={{ textAlign: isMobile ? "center" : "start" }}>
          <MenuFooter footerLinks={menuItems} />
        </div>
      </div>

      <Divider flexItem />

      <div
        style={{
          width: "80%",
          display: "flex",
          flexDirection: isMobile ? "column-reverse" : "row",
          justifyContent: "space-between",
        }}
      >
        <p>&copy; {currentYear} conecta-tech.uy</p>
      </div>
      <div style={{ padding: ".5rem" }}>
        <p style={{ fonSize: "8px", color: "#fafafa", textAlign: "start" }}>
          Sitio protegido por reCAPTCHA se aplican
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
            style={{ margin: "0 .15rem", color: "#fafafa" }}
          >
            Política de Privacidad
          </a>
          y
          <a
            href="https://policies.google.com/terms"
            target="_blank"
            rel="noopener noreferrer"
            style={{ margin: "0 .15rem", color: "#fafafa" }}
          >
            Términos de Servicio
          </a>
          de Google.
        </p>
      </div>
    </div>
  );
}

export default Footer;
